// import components
import { IconButton, Tooltip, Typography } from '@mui/material';
import {
  StyledButtonBoxWrapper,
  StyledTenantFooterBox
} from './TenantFooterBar.styles';
import { StyledSmallerIcon } from '../Icon/Icon.styles';

// import hooks
import { useEffect, useState } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import { t } from 'i18next';

// import types
import { TenantFooterBarProps } from './TenantFooterBar.types';

const TenantFooterBar = ({ tenantName }: TenantFooterBarProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const [isTenantFooterHidden, setIsTenantFooterHidden] =
    useSessionStorage<boolean>('isTenantFooterHidden', false);

  const handleClose = () => {
    setIsHidden(true);
    setTimeout(() => {
      setIsTenantFooterHidden(true);
    }, 600);
  };

  // listen for storage changes and update state
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'isTenantFooterHidden') {
        const newValue = event.newValue === 'true';
        setIsTenantFooterHidden(newValue);

        // If the session storage was cleared, reset isHidden to false
        if (!newValue) {
          setIsHidden(false);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  if (isTenantFooterHidden || !tenantName) {
    return null;
  }

  return (
    <StyledTenantFooterBox
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      isHidden={isHidden}
    >
      <Typography
        variant="inherit"
        sx={{
          fontSize: (theme) => theme.typography.htmlFontSize,
          fontFamily: 'SourceSansPro-Bold'
        }}
      >
        {tenantName}
      </Typography>

      <StyledButtonBoxWrapper isHovered={isHovered}>
        <Tooltip title={`${t('hide')}`} arrow>
          <IconButton size="small" onClick={handleClose}>
            <StyledSmallerIcon type="xmark" color="inherit" />
          </IconButton>
        </Tooltip>
      </StyledButtonBoxWrapper>
    </StyledTenantFooterBox>
  );
};

export default TenantFooterBar;
